module.exports = __webpack_public_path__ + "img/entrepreneur.c43b2890.png";